/** Tooltip copy for Course create/edit domain fields — presentation only. */
export const COURSE_DIALOG_FIELD_HELP = {
  domainName: "Topic area this course covers — for example Mathematics or Clinical Skills.",
  domainNameNew: 'Name of the domain you are about to add.',
  domainPercentage: 'Weight of this domain across all assessments. All domain percentages must total 100% or less.',
  domainPercentageNew: 'Weight for the new domain. Ensure the total across all domains stays at or below 100%.',
  subdomainName: "Sub-area within the domain — for example Algebra under Mathematics.",
  subdomainNameNew: 'Name of the subdomain you are about to add.',
  subTopics: 'Comma-separated list of specific topics Yaki uses when generating questions for this subdomain.',
  subTopicsNew: 'Comma-separated topics for the subdomain you are about to add.',
};
